import { render } from "./AiReviewPanel.vue?vue&type=template&id=5c7ca186"
import script from "./AiReviewPanel.vue?vue&type=script&lang=js"
export * from "./AiReviewPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__